import { render, staticRenderFns } from "./companyLinking.vue?vue&type=template&id=08305b22&scoped=true"
import script from "./companyLinking.vue?vue&type=script&lang=js"
export * from "./companyLinking.vue?vue&type=script&lang=js"
import style0 from "./companyLinking.vue?vue&type=style&index=0&id=08305b22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08305b22",
  null
  
)

export default component.exports